import { useState } from 'react';

const FAQS = [
  {
    q: 'Is Highlands, NC dog friendly?',
    a: 'Highlands is a dog-friendly mountain destination with outdoor trails, waterfalls, pet-friendly patios, and lodging options for travelers with dogs.',
  },
  {
    q: 'Are there pet-friendly cabins in Highlands NC?',
    a: 'Yes, Highlands offers pet-friendly cabin options for travelers bringing dogs, including cabins located near trails, waterfalls, and downtown Highlands.',
  },
  {
    q: 'What are some dog-friendly things to do in Highlands NC?',
    a: 'Popular dog-friendly activities in Highlands include hiking trails, waterfall visits, time at Highlands Dog Park, and outdoor dining at dog-friendly restaurants.',
  },
  {
    q: 'Can dogs go to Glen Falls in Highlands NC?',
    a: 'Dogs are generally welcome on leash on the Glen Falls trail, making it a popular stop for visitors exploring Highlands with pets.',
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="bg-[#F5F1EB] py-24 px-6 lg:px-14">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#C9A96E] text-xs tracking-[0.3em] uppercase font-jost mb-4">/ Common Questions</p>
          <h2 className="font-cormorant text-5xl text-[#1A1A18] font-light">
            FAQ<em className="italic"> — Dog-Friendly Highlands NC</em>
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {FAQS.map((item, idx) => (
            <article key={idx} className="bg-white rounded-2xl overflow-hidden">
              <button
                type="button"
                onClick={() => setOpen(open === idx ? null : idx)}
                className="w-full flex items-center justify-between gap-4 px-8 py-6 text-left cursor-pointer group"
                aria-expanded={open === idx}
              >
                <h3 className="font-cormorant text-xl text-[#1A1A18] font-medium leading-snug group-hover:text-[#2D4A3E] transition-colors">
                  {item.q}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center shrink-0 rounded-full bg-[#EDE8E0] transition-colors group-hover:bg-[#d8d1c6]">
                  <i className={`${open === idx ? 'ri-subtract-line' : 'ri-add-line'} text-[#2D4A3E] text-sm`} />
                </div>
              </button>
              {open === idx && (
                <div className="px-8 pb-7">
                  <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{item.a}</p>
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
